var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndiroba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1642_3288)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 8.70882 19.7553 7.47479 19.3097 6.34177C18.8696 5.22258 18.671 3.98696 19.0513 2.84605C19.4422 1.67341 18.3266 0.557804 17.1539 0.948683C16.013 1.32899 14.7774 1.13041 13.6582 0.690279C12.5252 0.244709 11.2912 0 10 0C4.47715 0 0 4.47715 0 10C0 11.2912 0.244706 12.5252 0.69027 13.6582C1.13039 14.7774 1.32896 16.013 0.948658 17.1539C0.557779 18.3266 1.67339 19.4422 2.84602 19.0513C3.98693 18.671 5.22257 18.8696 6.34176 19.3097C7.47479 19.7553 8.70882 20 10 20ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14814 7.20868C5.51382 6.57435 4.45053 6.63592 4.09627 7.46007C3.40099 9.07755 3.40099 10.9224 4.09627 12.5399C4.45053 13.3641 5.51382 13.4256 6.14814 12.7913L7.87879 11.0606C8.46458 10.4749 8.46458 9.52512 7.87879 8.93933L6.14814 7.20868Z",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2088 13.852C6.57448 14.4863 6.63604 15.5496 7.46019 15.9038C9.07767 16.5991 10.9225 16.5991 12.54 15.9038C13.3642 15.5496 13.4257 14.4863 12.7914 13.852L11.0608 12.1213C10.475 11.5355 9.52524 11.5355 8.93945 12.1213L7.2088 13.852Z",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8521 12.7913C14.4864 13.4256 15.5497 13.3641 15.904 12.5399C16.5992 10.9224 16.5992 9.07755 15.904 7.46007C15.5497 6.63592 14.4864 6.57436 13.8521 7.20868L12.1214 8.93933C11.5356 9.52512 11.5356 10.4749 12.1214 11.0606L13.8521 12.7913Z",
    fill: "#653024"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1642_3288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndiroba);
export default __webpack_public_path__ + "static/media/andiroba.401bea1a7154934c1cb77d8ee891099e.svg";
export { ForwardRef as ReactComponent };